var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{directives:[{name:"dialogDrag",rawName:"v-dialogDrag"}],attrs:{"top":"5vh","title":"语音通话","close-on-click-modal":false,"close-on-press-escape":false,"visible":_vm.isShow,"width":"50%"},on:{"update:visible":function($event){_vm.isShow=$event}}},[_c('div',{staticClass:"rtc-group-video"})])
}
var staticRenderFns = []

export { render, staticRenderFns }